"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // External links regexp, they start by one of those: 'http://', 'https://', '//'

var external = /^(https?:\/\/|\/\/)/i;

exports.isInternalLink = function (link) {
  return !external.test(link);
};

exports.default = exports.isInternalLink;